module.exports = __webpack_public_path__ + "img/border-center-h.9bdb4920.svg";